import RecentActivityResolver from 'resolvers/RTMResolvers/RecentActivityResolver';

/**
 * Builds a service to access Recent Activity List, and hold all of their business
 * logic.
 */
export default (() => {
  /**
   * @type {RecentActivityResolver}
   */
  let recentActivityResolver;
  let isRegistered = false;

  /**
   * Fetch Recent list
   * @param {string} accountId
   * @returns {object} 
   */
  const getRecentActivityList = async (accountId) => {
    const response = await recentActivityResolver.getRecentActivityList(accountId);
    return response;
  };

  return {
    isRegistered: () => isRegistered,

    register: (connectionProvider) => {
      isRegistered = true;
      recentActivityResolver = new RecentActivityResolver(connectionProvider);
    },
    getRecentActivityList,
  };
})();
